export default __webpack_public_path__ + "static/media/casf-white.ee9d8c8d.svg";